import {myDelegationsActions} from './my-delegations.actions';

const initialState = {
  delegations: [],
  users: [],
  loading: false,
  error: '',
  message: '',

  // Slice 4c. A separate slice from `delegations` above, which holds the INCUMBENT ownership
  // delegations — different objects (§1.2), and one merged list would say they are the same thing.
  access: {given: [], received: []},
  delegablePairs: [],
  delegates: [],
  // Default TRUE: the capability is granted per person (§3.6) and most users do not hold it, so the
  // un-provisioned state is the common case, not the exception. Starting at `false` would flash an
  // enabled drawer before the 403 came back.
  notProvisioned: true,
  accessDrawerKind: null,
  accessError: '',
};

export function myDelegationsReducer(state = initialState, action) {
  switch (action.type) {
    case myDelegationsActions.LOAD_REQUEST:
      return {...state, loading: true, error: ''};
    case myDelegationsActions.LOAD_SUCCESS:
      return {...state, loading: false, delegations: action.payload};
    case myDelegationsActions.LOAD_FAILURE:
      return {...state, loading: false, error: action.payload};
    case myDelegationsActions.LOAD_USERS_SUCCESS:
      return {...state, users: action.payload};
    case myDelegationsActions.MUTATION_SUCCESS:
      return {...state, message: action.payload, error: ''};
    case myDelegationsActions.MUTATION_FAILURE:
      return {...state, error: action.payload};
    case myDelegationsActions.CLEAR_MESSAGE:
      return {...state, message: '', error: '', accessError: ''};

    case myDelegationsActions.ACCESS_LOAD_SUCCESS:
      return {...state, access: {given: action.payload.given || [], received: action.payload.received || []}};
    case myDelegationsActions.ACCESS_DELEGABLE_SUCCESS:
      return {...state, delegablePairs: action.payload};
    case myDelegationsActions.ACCESS_DELEGATES_SUCCESS:
      // Reaching this at all means the route did not 403, which is the only signal the client has
      // that the caller holds `access.delegation:create`.
      return {...state, delegates: action.payload, notProvisioned: false};
    case myDelegationsActions.ACCESS_NOT_PROVISIONED:
      return {...state, notProvisioned: true, delegates: []};
    case myDelegationsActions.ACCESS_DRAWER_OPEN:
      return {...state, accessDrawerKind: action.payload, accessError: ''};
    case myDelegationsActions.ACCESS_DRAWER_CLOSE:
      return {...state, accessDrawerKind: null, accessError: ''};
    case myDelegationsActions.ACCESS_ERROR:
      return {...state, accessError: action.payload};

    default:
      return state;
  }
}

export default myDelegationsReducer;
